import {
  Blockquote,
  Button,
  ButtonGroup,
  Stack,
  Title,
  Text,
  Container,
} from "@mantine/core";
import { useParams } from "react-router";
import { useCancel } from "../hooks/useCancel";
import { trackEvent } from "../analytics";

export const Cancelation = () => {
  const params = useParams<"registrationId">();
  const registrationId = params.registrationId;
  if (!registrationId) {
    throw new Error("registration id not given");
  }

  const cancelMutation = useCancel();

  const onCancel = async () => {
    trackEvent("abmeldung-abgeschickt");

    try {
      const response = await cancelMutation.mutateAsync({ id: registrationId });

      if (response.response.ok) {
        trackEvent("abmeldung-erfolgreich");
      } else {
        trackEvent("abmeldung-fehlgeschlagen", {
          grund: `status-${response.response.status}`,
        });
      }
    } catch {
      trackEvent("abmeldung-fehlgeschlagen", { grund: "netzwerkfehler" });
    }
  };

  return (
    <Container size="md">
      <Stack>
        <Title order={2}>Vom Vortrag abmelden</Title>
        <Text>
          Sie können nicht am Vortrag teilnehmen? Melden Sie sich hier ganz
          einfach ab.
        </Text>
        {!cancelMutation.isSuccess && (
          <ButtonGroup>
            <Button
              radius="xl"
              color="red"
              size="md"
              loading={cancelMutation.isPending}
              onClick={onCancel}
            >
              Vom Vortrag abmelden
            </Button>
          </ButtonGroup>
        )}
        {cancelMutation.isSuccess && (
          <>
            <Blockquote color="green">
              Vielen Dank, wir haben Ihre Abmeldung erhalten.
            </Blockquote>
          </>
        )}
      </Stack>
    </Container>
  );
};
